<template>
    <div>
        <div class="register_page_subtitle">
            Hola {{ name }}, ya tienes un usuario.
        </div>
        <div class="register_page_username">
            {{ username }}
        </div>
        <div class="register_page_user_exist_info">
            Quizás has tenido algún
            contacto con la Universidad del Pacífico en el pasado.
        </div>
        <div class="register_page_button">
            <v-btn
                color="primary"
                class="uppercase"
                @click="toLogin"
                >Iniciar Sesión
            </v-btn>
        </div>
        <div class="register_page_forgot_password">
            <a 
                :href="forgotPasswordUrl" 
                class="register_page_forgot_password_link"
                target="_blank"
                >
                Olvidé mi contraseña
            </a>
        </div>
        
    </div>
</template>
<script>
import {mapActions} from 'vuex';
export default {
    props: ['name','username'],
    data() {
        return {
            forgotPasswordUrl: "https://srvnetappseg.up.edu.pe/siserpwd/"
        }
    },
    methods: {
        ...mapActions(['resetRegister']),
        toLogin(){
            this.resetRegister();
            this.$router.push("/login");
            //location.reload();
        }
    },
}
</script>